/**
 * 经销商管理
 * @author sunxx
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async saveFormDetail(rowId,dealerNo) {
		return request(api.comm.DEPT+ '/updateDealerNo?deptId='+rowId+'&dealerNo='+dealerNo, METHOD.GET);
	},

}


export default {dataApi}
